<template>
  <div v-if="segments.length > 1" class="title white--text py-3">
    <span v-for="(path, index) in segments" :key="path.slug">
      <nuxt-link v-if="path.slug !== $route.path" :to="path.slug" class="breadcrumb--link">{{ path.text }}</nuxt-link>
      <span v-else style="font-weight: bold">{{ path.text }}</span>
      <span v-if="index !== segments.length - 1"> > </span>
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    segments() {
      const segments = [];

      this.$route.path.split('/')
        .filter(segment => segment !== '')
        .forEach((segment, i) => {
          segments.push({
            text: segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '),
            slug: i !== 0 ? `${segments[i - 1].slug}/${segment}` : `/${segment}`,
          });
        });

      return segments;
    },
  },
};
</script>

<style lang="sass" scoped>
.breadcrumb--link
  color: white
  text-decoration: none
  opacity: 0.8
</style>
